import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import { CheckboxComponent } from '../components/CheckboxComponent';
import { EventActionHeaderbar } from './ClientPlace/EventActionHeaderBar';
import { FileDownloader } from '../common/helpers/FileDownloader';
import { SearchHelper } from '../helpers/SearchHelper';
import { AppHelper } from '../helpers/AppHelper.js'
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Toggler } from '../common/components/Toggler';
import { adminData } from '../data/AdminData.js';
import { appData } from '../data/AppData.js';
import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import { ColourPalette } from '../styles/AppColourPalette';
import { Controller } from '../common/Controller';

export class Reports extends Component {
  constructor(props) {
    super(props);
    this.placeId = this.props.match.params.id ? this.props.match.params.id : null;
    this.eventsByGroupId = {}
    this.grpDisplayMode = false
    this.responseByKey = {
      selectedCamIds: [],
      toDateTs: null,
      fromDateTs: null,
      eventFields: [],
      eventImages: [],
      priorityFilters: [],
      tagFilters: []
    }
    this.tagValue = {}
    this.orgId = null
    this.pdfAttrColWidth = {
      camId: 80,
      // eslint-disable-next-line camelcase
      event_time: 120,
      name: 90,
      type: 90,
      tags: 120,
      priority: 5,
      priorityReported: 5,
    }
    this.eventsByType = {}
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      eventList: [],
      eventCompleteList: [],
      eventListLoading: false,
      pageNumber: 0,
      paginate: false,
      downloadDialog: false,
      downloadDialogErrorTitle: '',
      downloadDialogErrorDesc: ''
    }
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems = () => {
    ApiHelper.call(
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['places', this.placeId]) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.orgId = result.orgId

        this.setFields(result)
        this.setBreadcrumbs(result)

        this.setState({
          place: result,
        }, () => this.updateEvents())
      }.bind(this))
  }

  setFields = (result) => {
    for (const cam of result.cams) {
      appData.reportFields.selectCam.options.push({
        key: cam._id,
        name: cam.name
      })
    }

    if (result.cams.length > 0 &&
      (!this.responseByKey.selectedCamIds || this.responseByKey.selectedCamIds.length === 0)) {
      this.responseByKey.selectedCamIds = [result.cams[0]._id]
    }

    appData.reportFields.eventFields.options = adminData.eventFields
    appData.reportFields.eventImages.options = adminData.eventImages

    if (this.props.location.state && this.props.location.state.selectedCamIds) {
      this.responseByKey.selectedCamIds = this.props.location.state.selectedCamIds
    }
    if (this.props.location.state && this.props.location.state.toDateTs) {
      this.responseByKey.toDateTs = this.props.location.state.toDateTs
    }
    if (this.props.location.state && this.props.location.state.fromDateTs) {
      this.responseByKey.fromDateTs = this.props.location.state.fromDateTs
    }
    if (this.props.location.state && this.props.location.state.tagValue) {
      this.tagValue = this.props.location.state.tagValue
    }
    if (this.props.location.state && this.props.location.state.tagFilters) {
      this.responseByKey.tagFilters = this.props.location.state.tagFilters
    }
    if (this.props.location.state && this.props.location.state.priorityFilters) {
      this.responseByKey.priorityFilters = this.props.location.state.priorityFilters
    }
  }

  updateEvents = (action) => {
    const params = {
      priority: AppHelper.getGlobalPriotiyValue(),
      limit: AppConfig.eventQueryLimit,
    }

    if (this.responseByKey.fromDateTs && this.responseByKey.toDateTs) {
      params.fromDateTs = this.responseByKey.fromDateTs
      params.toDateTs = this.responseByKey.toDateTs
    }

    params.camId = this.responseByKey.selectedCamIds

    if (action === 'next') {
      this.eventsByType = {}
      this.setState({
        eventList: [],
        eventListLoading: true
      })

      if (!this.state.paginate) {
        return
      }

      params.pageNumber = this.state.pageNumber + 1
    }

    if (action === 'prev') {
      this.eventsByType = {}
      this.setState({
        eventList: [],
        eventListLoading: true
      })

      if (this.state.pageNumber === 0) {
        return
      }

      params.pageNumber = this.state.pageNumber - 1
    }

    const options = {
      method: 'GET',
      endPoint: ApiHelper.makeUrlPath(['places', this.placeId, 'events'], params)
    }

    ApiHelper.call(
      options,
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.setState({
          pageNumber: result.currPageNumber,
          paginate: result.more ? true : false,
          eventCompleteList: result.items,
          eventList: this.grpDisplayMode ? this.processEvents(result.items) : this.filterWithParams(result.items),
          eventListLoading: false,
          fetchState: ApiHelper.State.READY
        })

      }.bind(this))
  }

  processEvents = (items) => {
    items = this.filterWithParams(items)
    this.eventsByGroupId = {}
    const modifiedEventList = []
    for (const item of items) {
      if (!item.groupId) {
        modifiedEventList.push(item)
        continue
      }

      if (this.eventsByGroupId[item.groupId] === undefined) {
        modifiedEventList.push(item)
        this.eventsByGroupId[item.groupId] = []
      } else {
        this.eventsByGroupId[item.groupId].push(item)
      }
    }

    this.setEventsByType(modifiedEventList)
    return modifiedEventList
  }

  setEventsByType = (events) => {
    this.eventsByType = {}
    for (const event of events) {
      if (event.type === 'null' || event.type === 'undefined') {
        continue
      }
      if (!event.type) {
        continue
      }
      if (this.eventsByType[event.type]) {
        this.eventsByType[event.type] = this.eventsByType[event.type] + 1
      } else {
        this.eventsByType[event.type] = 1
      }
    }
  }

  setValue = (value, key) => {
    this.responseByKey[key] = value
    this.setState({
      eventList: this.grpDisplayMode ? this.processEvents(this.state.eventCompleteList) : this.filterWithParams(this.state.eventCompleteList),
    })
  }

  timeChangeHandler = (fromDateTs, toDateTs) => {
    this.responseByKey.fromDateTs = fromDateTs
    this.responseByKey.toDateTs = toDateTs
    this.updateEvents()
  }

  filterHandler = (tagFilters, priorityFilters, tagValue) => {
    this.responseByKey.tagFilters = tagFilters
    this.responseByKey.priorityFilters = priorityFilters
    this.tagValue = tagValue
    this.setState({
      eventList: this.grpDisplayMode ? this.processEvents(this.state.eventCompleteList) : this.filterWithParams(this.state.eventCompleteList),
    })
  }

  camSelectHandler = (camIds) => {
    this.responseByKey.selectedCamIds = camIds
    this.updateEvents()
  }

  filterWithParams = (items) => {
    let eventListAfterFilter = []
    if (this.searchText) {
      eventListAfterFilter = SearchHelper.filterItemsBySearchText(this.searchText, items)
    } else {
      eventListAfterFilter = items
    }

    if (this.responseByKey.tagFilters && this.responseByKey.tagFilters.length > 0) {
      eventListAfterFilter = SearchHelper.filterItemsByTag(this.responseByKey.tagFilters, this.tagValue, eventListAfterFilter)
    }

    if (this.responseByKey.priorityFilters && this.responseByKey.priorityFilters.length > 0) {
      eventListAfterFilter = SearchHelper.filterItemsByPriority(this.responseByKey.priorityFilters, eventListAfterFilter)
    }

    this.setEventsByType(eventListAfterFilter)

    return eventListAfterFilter
  }

  getEventCount = () => {
    return 'Page ' + (this.state.pageNumber + 1)
  }

  getPaginationData = () => {
    if (this.state.paginate || this.state.pageNumber !== 0) {
      return (
        <div className={css(Styles.paginationContainer)}>
          <Tooltip title='Previous'>
            <IconButton disabled={this.state.pageNumber === 0} className={css(Styles.refreshIconContainer)}>
              <Icon className={css(Styles.refreshIcon)} color='primary' onClick={() => this.updateEvents('prev')}>
                navigate_before
              </Icon>
            </IconButton>
          </Tooltip>

          <p className={css(Styles.pageNumber)}>{this.getEventCount()}</p>

          <Tooltip title='Next'>
            <IconButton disabled={!this.state.paginate} className={css(Styles.refreshIconContainer)}>
              <Icon className={css(Styles.refreshIcon)} color='primary' onClick={() => this.updateEvents('next')}>
                navigate_next
              </Icon>
            </IconButton>
          </Tooltip>
        </div>
      )
    } else {
      return ''
    }
  }

  showDownloadDialog = () => {
    if (this.state.eventList.length === 0) {
      this.setState({ downloadDialogErrorTitle: 'Empty list', downloadDialogErrorDesc: Helper.getString('noEventsFound') })
    } else if (!this.responseByKey.eventFields || this.responseByKey.eventFields.length === 0) {
      this.setState({ downloadDialogErrorTitle: 'Empty event field', downloadDialogErrorDesc: Helper.getString('noEventFields') })
    }

    this.setState({ downloadDialog: true })
  }

  closeDownloadDialog = () => {
    this.setState({
      downloadDialog: false
    }, () => {
      this.setState({
        downloadDialogErrorTitle: '',
        downloadDialogErrorDesc: ''
      })
    })
  }

  makeFileName = () => {
    let fileName;

    let dateExtension = '-events'

    if (this.responseByKey.fromDateTs && this.responseByKey.toDateTs) {
      dateExtension = '_ ' +
        'from-' +
        moment(this.responseByKey.fromDateTs).format('YYYY') +
        '-' +
        moment(this.responseByKey.fromDateTs).format('MM') +
        '-' +
        moment(this.responseByKey.fromDateTs).format('DD') +
        '-to-' +
        moment(this.responseByKey.toDateTs).format('YYYY') +
        '-' +
        moment(this.responseByKey.toDateTs).format('MM') +
        '-' +
        moment(this.responseByKey.toDateTs).format('DD')
    }

    if (this.responseByKey.selectedCamIds) {
      fileName = 'doc' + '-' + 'cams' + dateExtension;
    } else {
      fileName = 'doc' + '-' + dateExtension;
    }

    return fileName;
  }

  downloadAsExcel = (eventList) => {
    const fileName = this.makeFileName();
    FileDownloader.prepExcelDownload(
      eventList,
      this.responseByKey.eventFields,
      fileName,
      'event_time',
      this.eventsByGroupId
    );
    this.setState({ downloadDialog: false })
  }

  downloadAsPdf = (eventList) => {
    const fileName = this.makeFileName();
    const columnStyles = {};
    columnStyles['0'] = { cellWidth: 5 };
    this.responseByKey.eventFields.forEach((element, index) => {
      columnStyles[index + 1] = { cellWidth: this.pdfAttrColWidth[element] };
    });

    FileDownloader.prepPdfDownload(
      eventList,
      this.responseByKey.eventFields,
      fileName,
      columnStyles,
      this.eventsByGroupId
    );
    this.setState({ downloadDialog: false })
  }

  downloadDialogFunction = () => {
    return (
      <Dialog
        onClose={this.closeDownloadDialog}
        open={this.state.downloadDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}>

        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>
            {this.state.downloadDialogErrorTitle ? this.state.downloadDialogErrorTitle : 'Download'} </p>
        </DialogTitle>

        {this.state.downloadDialogErrorTitle &&
          <DialogContent className={css(Styles.dialogContent)}>
            <p className={css(Styles.dialogContentData)}>{this.state.downloadDialogErrorDesc}</p>
          </DialogContent>
        }

        {this.state.downloadDialogErrorTitle &&
          <DialogActions className={css(Styles.dialogActions)}>
            <Button
              variant='contained'
              onClick={this.closeDownloadDialog}
              className={css(Styles.dailogActionButton)}>
              OK
            </Button>
          </DialogActions>
        }

        {!this.state.downloadDialogErrorTitle &&
          <DialogActions className={css(Styles.dialogActions)}>
            <Button
              variant='contained'
              onClick={() => this.downloadAsExcel(this.state.eventList)}
              className={css(Styles.dailogActionButton)}>
              Download Excel
            </Button>

            <Button
              variant='contained'
              onClick={() => this.downloadAsPdf(this.state.eventList)}
              className={css(Styles.dailogActionButton)}>
              Download PDF
            </Button>
          </DialogActions>
        }
      </Dialog>
    );
  }

  setBreadcrumbs = (item) => {
    this.breadcrumbs = [
      {
        title: 'Places',
        to: '/orgs/' + item.orgId + '/places'
      },
      {
        title: 'Reports',
        to: ''
      },
    ]
  }

  renderFilterResult = () => {
    return (
      <div className={css(Styles.eventContainer)}>
        <div className={css(Styles.eventContainerHeader)}>

          <div className={css(Styles.statsContainer)}>
            <p className={css(Styles.headerContainer)}>Total Events | {this.state.eventList.length}</p>
            <div className={css(Styles.eventEditContainer, Styles.eventEditContainerStyle)}>
              {Object.keys(this.eventsByType).map((key, index) => {
                return (
                  <div className={css(Styles.tagContainer)}>
                    <p className={css(Styles.tagKey)}>{key}</p>
                    <p className={css(Styles.tagValueVariant)}>{this.eventsByType[key]}</p>
                  </div>
                )
              })}
            </div>
          </div>

          <div className={css(Styles.downloadContainer)}>

            {this.getPaginationData()}

            <Tooltip title={Helper.getString('downloadEventsWithImages')}>
              <Icon className={css(Styles.downloadIcon)} onClick={() => window.print()}>
                save
              </Icon>
            </Tooltip>

            <Tooltip title={Helper.getString('downloadEventsWithNoImages')}>
              <div className={css(Styles.downloadImage)} onClick={() => this.showDownloadDialog()}>
                <img src={require('../assets/images/download-img1.svg')} />
              </div>
            </Tooltip>

          </div>
        </div>

        {this.eventTable()}

      </div>
    )
  }

  renderFilters = () => {
    return (
      <div className={css(Styles.formOuterContainer)}>
        <div className={css(Styles.formInnerContainer)}>
          <CheckboxComponent
            formField={appData.reportFields.eventFields}
            value={this.responseByKey[appData.reportFields.eventFields.key] ? this.responseByKey[appData.reportFields.eventFields.key] : []}
            setValue={this.setValue.bind(this)}
            disabled={false} />
          <CheckboxComponent
            formField={appData.reportFields.eventImages}
            value={this.responseByKey[appData.reportFields.eventImages.key] ? this.responseByKey[appData.reportFields.eventImages.key] : []}
            setValue={this.setValue.bind(this)}
            disabled={false} />
        </div>
      </div>
    )
  }

  onEventClick = (item) => {
    Controller.get().pushRouteWithQueryParams('/places/' + this.placeId, '?camId=' + item.camId, { event: item })
  }

  eventTable = () => {
    if (this.state.eventListLoading) {
      return (
        <div className={css(Styles.progressContainer)}>
          <CircularProgress size={30} className={css(Styles.progress)} />
        </div>
      )
    }

    return (
      <Table className={css(Styles.tableOuterContainer)}>
        <TableHead className={css(Styles.tableHead)}>
          <TableRow className={css(Styles.tableRow)}>
            <TableCell
              align='left'
              className={css(Styles.tableHeader)}>
              <p>SL.No</p>
            </TableCell>

            {(!this.responseByKey.eventFields || this.responseByKey.eventFields.length === 0) ?
              adminData.eventFields.map(events => {
                return (
                  <TableCell
                    align='left'
                    className={css(Styles.tableHeader)}>
                    {events.name}
                  </TableCell>
                )
              })
              :
              adminData.eventFields.map(field => {
                return (
                  this.responseByKey.eventFields.map(key => {
                    return (
                      key === field.key &&
                      <TableCell
                        align='left'
                        className={css(Styles.tableHeader)}>
                        {field.name}
                      </TableCell>
                    )
                  }))
              })
            }

          </TableRow>
        </TableHead>

        <TableBody>
          {this.responseByKey.eventFields.length === 0 ?
            this.state.eventList.map((item, index) => {
              return (
                <TableRow className={css(Styles.tableRow)}>
                  <TableCell align='left' className={css(Styles.tableItem)}>
                    <p>{index + 1 + (this.state.pageNumber * AppConfig.eventQueryLimit)}</p>
                    <div onClick={() => this.onEventClick(item)} className={css(Styles.menuHeaderRoleConatiner)}>
                      <p className={css(Styles.menuHeaderRole)}>{'VIEW'}</p>
                    </div>
                  </TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>{item.camId}</TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>
                    {moment(item.event_time).format('MMM DD, YYYY, h:mm:ss A')}
                  </TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>{item.name}</TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>{AppHelper.getPriorityStr(item.priority)}</TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>{AppHelper.getPriorityStr(item.priorityReported)}</TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>{this.renderTypes(item.type)}</TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>{this.renderTags(item)}</TableCell>
                  <TableCell >
                    {this.responseByKey.eventImages.length === 0 ?
                      <div className={css(Styles.eventListImageContainer)}>
                        <img
                          key={item.image}
                          src={item.image}
                          className={css(Styles.eventImg)}></img>
                      </div>
                      :
                      this.responseByKey.eventImages.map(key => {
                        return (
                          this.eventImage(item, key)
                        )
                      })
                    }
                  </TableCell>
                  <TableCell align='left' className={css(Styles.tableItem)}>{this.eventsByGroupId[item.groupId] ? (this.eventsByGroupId[item.groupId].length + 1) : 1}</TableCell>
                </TableRow>
              )
            })
            :
            this.state.eventList.map((item, index) => {
              return (
                <TableRow className={css(Styles.tableRow)}>
                  <TableCell align='left' className={css(Styles.tableItem)}>{index + 1 + (this.state.pageNumber * AppConfig.eventQueryLimit)}</TableCell>
                  {adminData.eventFields.map(field => {
                    return (
                      this.responseByKey.eventFields.map(key => {
                        return (
                          field.key === key &&
                          this.evenSelectedfunction(item, key)
                        )
                      })
                    )
                  })}
                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    )
  }

  eventImage = (item, key) => {
    const imgArr = [];
    if (key === 'primaryImage') {
      imgArr.push(
        <div className={css(Styles.eventListImageContainer)}>
          <img
            key={item.image}
            src={item.image}
            className={css(Styles.eventImg, Styles.eventListImageConatinerSecondary)}></img>
        </div>
      )
    } else if (key === 'secondaryImage' &&
      item.additionalImages &&
      item.additionalImages.length > 0) {
      imgArr.push(
        <div className={css(Styles.eventListImageContainer)}>
          <img
            key={item.additionalImages[0]}
            src={item.additionalImages[0]}
            className={css(Styles.eventImg)}></img>
        </div>
      )
    }
    return imgArr
  }

  renderTypes = (type) => {
    if (type === 'null' || type === 'undefined') {
      return null
    }
    return type
  }

  renderTags = (item) => {
    if (!item.tags) {
      return ''
    }
    const tagKeys = Object.keys(item.tags)
    return (
      <div className={css(Styles.tagsContainer)}>
        {tagKeys.map((tagK, index) => {
          return (
            <p className={css(Styles.tagValue)}>{tagK} : {item.tags[tagK]}</p>
          )
        })}
      </div>
    )
  }


  evenSelectedfunction = (item, key) => {
    if (key === 'camId') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {item.camId}
        </TableCell>
      )
    }
    else if (key === 'event_time') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {moment(item.event_time).format('MMM DD, YYYY, h:mm:ss A')}
        </TableCell>
      )
    }
    else if (key === 'name') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {item.name}
        </TableCell>
      )
    }
    else if (key === 'priority') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {AppHelper.getPriorityStr(item.priority)}
        </TableCell>
      )
    }
    else if (key === 'priorityReported') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {AppHelper.getPriorityStr(item.priorityReported)}
        </TableCell>
      )
    }
    else if (key === 'type') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {this.renderTypes(item.type)}
        </TableCell>
      )
    } else if (key === 'tags') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {this.renderTags(item)}
        </TableCell>
      )
    } else if (key === 'image') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {this.responseByKey.eventImages.length === 0 ?
            <div className={css(Styles.eventListImageContainer)}>
              <img
                key={item.image}
                src={item.image}
                className={css(Styles.eventImg)}></img>
            </div>
            :
            this.responseByKey.eventImages.map(key => {
              return (
                this.eventImage(item, key)
              )
            })
          }
        </TableCell>
      )
    } else if (key === 'grouped_events') {
      return (
        <TableCell align='left' className={css(Styles.tableItem)}>
          {this.eventsByGroupId[item.groupId] ? (this.eventsByGroupId[item.groupId].length + 1) : 1}
        </TableCell>
      )
    }
  }

  onGroupedDisplayChange = (value) => {
    this.grpDisplayMode = value
    if (value) {
      this.setState({
        eventList: this.processEvents(this.state.eventCompleteList)
      })
    } else {
      this.eventsByGroupId = {}
      this.setState({
        eventList: this.filterWithParams(this.state.eventCompleteList)
      })
    }
  }

  readyView = () => {

    return (
      <div className={css(CommonStyles.outerMainContainer)} id='ifmcontentstoprint'>

        <EventActionHeaderbar
          breadcrumbs={this.breadcrumbs}
          title={this.state.place.name}
          timeChangeHandler={this.timeChangeHandler}
          camSelectHandler={this.camSelectHandler}
          filterHandler={this.filterHandler}
          place={this.state.place}
          selectedCamIds={this.responseByKey.selectedCamIds}
          toDateTs={this.responseByKey.toDateTs}
          fromDateTs={this.responseByKey.fromDateTs}
          onGroupedDisplayChange={this.onGroupedDisplayChange}
        />

        <div className={css(CommonStyles.innerMainContainer)}>
          <div className={css(Styles.innerContainer)}>

            {this.renderFilters()}

            {this.renderFilterResult()}

          </div>
        </div>

        {this.state.downloadDialog &&
          this.downloadDialogFunction()
        }

      </div>
    )
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }
}

const Styles = StyleSheet.create({
  tableHeader: {
    fontSize: 18,
    fontWeight: 'bold',
    flex: 1,
    minWidth: 'unset',
    color: AppTheme.white,
  },
  tableRow: {
    backgroundColor: '#202633',
    borderRadius: '4px 4px 0 0',
  },
  tableItem: {
    color: AppTheme.white,
    fontWeight: 'bolder'
  },
  tableOuterContainer: {
  },
  tableHead: {
    marginTop: 10,
    backgroundColor: AppTheme.primaryBackground,
  },
  eventListImageContainer: {
    width: 100,
    display: 'flex',
    marginBottom: 5,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  eventListImageConatinerSecondary: {
    marginTop: 5
  },
  eventImg: {
    width: '100%'
  },
  pageNumber: {
    opacity: 0.7,
    color: AppTheme.white,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      fontSize: 15,
    }
  },
  refreshIconContainer: {
    padding: '0px 12px',
    ':hover': {
      backgroundColor: AppTheme.primaryBackground,
    },
    '@media (max-width: 767px)': {
      padding: '0px 5px',
    }
  },
  refreshIcon: {
    borderRadius: '50%',
    cursor: 'pointer',
    opacity: 0.5,
    color: AppTheme.white,
    ':hover': {
      backgroundColor: '#1D2331',
    }
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  downloadImage: {
    paddingLeft: 10,
    paddingRight: 10,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    marginTop: 5,
    '@media (max-width: 767px)': {
      paddingLeft: 5,
      paddingRight: 5,
    }
  },
  formOuterContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.primaryBackground,
    padding: 20,
    paddingTop: 0,
    paddingBottom: 0
  },
  innerContainer: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 50,
    marginBottom: 50,
  },
  formInnerContainer: {
    display: 'flex',
    flex: 1,
  },
  eventContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.secondaryColor,
    marginTop: 10,
    overflowX: 'scroll'
  },
  eventContainerHeader: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: AppTheme.primaryBackground,
    padding: 10,
    borderRadius: '4px 4px 0 0',
  },
  downloadContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  dialogTitle: {
    padding: 20,
    backgroundColor: AppTheme.white
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 16,
    margin: 0,
    color: AppTheme.primaryBackground,
  },
  dialogContent: {
    padding: 0,
    backgroundColor: AppTheme.primaryBackground,
    marginBottom: -1
  },
  dialogContentData: {
    margin: 0,
    padding: '15px 20px 0px 20px',
    fontWeight: 600,
    opacity: 0.6,
    color: AppTheme.white,
  },
  dialogActions: {
    padding: 20,
    display: 'flex',
    justifyContent: 'flex-start',
    backgroundColor: AppTheme.primaryBackground,
  },
  dailogActionButton: {
    fontWeight: 'bolder',
    margin: 0,
    marginRight: 10,
    fontSize: 15,
    textTransform: 'unset',
    backgroundColor: ColourPalette.color3,
    color: AppTheme.white,
    padding: '5px'
  },
  headerContainer: {
    fontSize: 18,
    fontWeight: 'bold',
    flex: 1,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    color: AppTheme.white,
    '@media (max-width: 767px)': {
      fontSize: 16,
    }
  },
  downloadIcon: {
    paddingLeft: 10,
    paddingRight: 10,
    cursor: 'pointer',
    color: ColourPalette.color1,
    '@media (max-width: 767px)': {
      paddingLeft: 5,
      paddingRight: 5,
    }
  },
  dialog: {
    minWidth: 500,
  },
  progressContainer: {
    minHeight: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  progress: {
    color: ColourPalette.color1
  },
  tagsContainer: {
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    fontWeight: 'bolder'
  },
  tagValue: {
    margin: 0,
    marginBottom: 5
  },
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  tagContainer: {
    border: '1px solid #566380',
    marginTop: 10,
    marginRight: 15,
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tagContainerDetail: {
    border: '1px solid #6c6c6c',
    borderRadius: 5,
  },
  tagKey: {
    backgroundColor: ColourPalette.color1,
    margin: 0,
    color: AppTheme.primaryBackground,
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 5,
    borderRadius: '4px 0px 0px 4px',
    cursor: 'default'
  },
  tagValueVariant: {
    margin: 0,
    color: '#C7C9CB',
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 4,
    cursor: 'default'
  },
  eventEditContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  eventEditContainerStyle: {
    marginTop: 10,
    flex: 1,
    //justifyContent: 'flex-end'
  },
  menuHeaderRoleConatiner: {
    cursor: 'pointer',
    backgroundColor: ColourPalette.color1,
    marginRight: 5,
    borderRadius: 5,
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    '@media(max-width: 767px)': {
      marginTop: 5
    }
  },
  menuHeaderRole: {
    margin: 0,
    color: AppTheme.primaryBackground,
    fontSize: 13,
    fontWeight: 'bold'
  },
})



// WEBPACK FOOTER //
// ./src/screens/Reports.js